import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

var featureTextCarousel = new Swiper(".feature-text-carousel", {
	slidesPerView: 1,
	loop: true,
	navigation: {
		prevEl: '.swiper-feature-text-prev',
		nextEl: '.swiper-feature-text-next'
	}
});

var roomsCarousel = new Swiper(".rooms-carousel", {
	slidesPerView: 1,
	loop: true,
	speed: 1000,
	pagination: {
		el: ".rooms-pagination",
		type: "fraction",
	},
	navigation: {
		prevEl: '.rooms-prev',
		nextEl: '.rooms-next'
	}
});

var freeflowCarousel = new Swiper(".freeflow-carousel", {
	slidesPerView: "auto",
	centeredSlides: true,
	spaceBetween: 32,
	navigation: {
		prevEl: '.freeflow-carousel-prev',
		nextEl: '.freeflow-carousel-next'
	},
	breakpoints: {
		1280: {
			centeredSlides: false,
			slidesOffsetBefore: window.innerWidth * 0.33333,
			slidesOffsetAfter: 32,
		}
	},
	on: {
		activeIndexChange: (e) => {
			const bookARoom = document.querySelector('#bookARoom');
			const bookARoomLogo = document.querySelector('.bookARoomLogo');
			if (bookARoom) {
				if (e.activeIndex === 0) {
					bookARoom.classList.remove('xl:invisible', 'xl:pointer-events-none', 'xl:opacity-0')
					bookARoomLogo.classList.remove('xl:invisible', 'xl:pointer-events-none', 'xl:opacity-0')
				} else {
					bookARoom.classList.add('xl:invisible', 'xl:pointer-events-none', 'xl:opacity-0')
					bookARoomLogo.classList.add('xl:invisible', 'xl:pointer-events-none', 'xl:opacity-0')
				}
			}
		}
	}
});

var partnersCarousel = new Swiper(".partners-carousel", {
	slidesPerView: 2,
	spaceBetween: 60,
	speed: 1000,
	navigation: {
		prevEl: '.partners-prev',
		nextEl: '.partners-next',
	},
	breakpoints: {
		768: {
			slidesPerView: 3,
			spaceBetween: 100,
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 180,
		}
	}
})